import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ReservationformService } from "../reservationform/reservationform.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import { NgForm } from "@angular/forms";
import { ReservationFieldsFormComponent } from "./reservation-fields-form/reservation-fields-form.component";
import { GuestlistStepComponent } from "./guestlist-step/guestlist-step.component";

@Component({
  selector: "app-newreservationform",
  templateUrl: "./newreservationform.component.html",
  styleUrls: ["./newreservationform.component.scss"]
})
export class NewreservationformComponent implements OnInit, AfterViewInit {
  @ViewChild('fnameInput') fnameInput: ElementRef;
  acceptInternationalNumbers: boolean = false;
  imageSrc: string = null;
  currentStep: string;
  record: any = {};
  guests: any;
  branches: any;
  slots: any;
  routeObs$: any;
  token: string;
  fbId: string;
  disclaimerText = '';
  startText: string = null;
  endText: string = null;
  noteText: string = null;
  publicTags: any = [];
  metaDataLoaded = false;
  showGuestsList = false;
  showSlotEndTime = true;
  mobileNumberAtGlMandatory = false;
  cutOffTime: any = -1;
  seatingType = true;
  commentsLabel: string = 'Comments & Notes';
  isTicketType = false;
  showBranchRow = true;
  createCustomerAsGuest = true;
  loading = false;
  mobileNoIsReadOnly = false;
  fbHeadMandatory = false;
  fbGuestMandatory = false;
  emailGuestMandatory = false;
  ticketPrices: any;
  formattedBranch: any;
  formattedSlot: any;
  formattedDate: any;
  stepTitle: string;
  titleFontLarge;
  titleSpaceLarge;
  maxPaxValid = false;
  minPaxValid: boolean = false;
  ng2TelInputOptions: any;
  MESSAGES_TICKETSOLDOUT_TITLE: string = "Tickets are Sold out";
  MESSAGES_TICKETSOLDOUT_DESC: string =
    " can not purchase this ticket because it is sold out.";
  MESSAGES_TICKETINVALIDTYPE_TITLE: string =
    "Ticket Type is not compatible with Reservation type.";
  MESSAGES_TICKETINVALIDTYPE_DESC: string =
    " can not purchase this ticket type because it is not designed with the reservation type.(Seated/Standing)";

  @ViewChild("f") newForm: NgForm;
  @ViewChild("fieldsform") fieldsForm: ReservationFieldsFormComponent;
  @ViewChild("guestlistForm") guestlistForm: GuestlistStepComponent;
  acceptInstagramOnly: boolean = false;
  SocialMediaLinkCustomLabel: string = "";
  allPlatformsPattern: string = "^(?:https?:\\/\\/)?(?:www\\.)?(?:(?:facebook\\.com\\/(?:(?:\\w)*#!\\/)?(?:pages\\/)?(?:[?\\w\\-]*\\/)?(?:profile\\.php\\?id=)?|m\\.facebook\\.com\\/(?:(?:\\w)*#!\\/)?(?:profile\\.php\\?id=))([^\\s&]+))(?:&.*)?$|(?:instagram\\.com\\/([^\\s\\/&]+))|(?:https?:\\/\\/x\\.com\\/([^\\s\\/&]+))(?:\\?.*)?$";
  instagramOnlyPattern: string = "^(?:https?:\\/\\/)?(?:www\\.)?instagram\\.com\\/.+$";
  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private globals: Globals,
    private reservationformService: ReservationformService
  ) {
    this.guests = [];
    this.branches = [];
    this.slots = [];
  }

  ngAfterViewInit() {
    this.fnameInput.nativeElement.focus();
  }

  onKeyPress(event: KeyboardEvent) {
    const char = String.fromCharCode(event.charCode);
    if (!/^\d+$/.test(char)) { // Regular expression to allow only digits
      event.preventDefault();
    }
  }

  reset() {
    this.showLandingStep();
    this.newForm.reset();
    this.record = {};
    this.guests = [];
    setTimeout(() => {
      // this.record.typeid = "1";
      this.record.pax = 2;
      this.record.gender = "m";
      this.record.tags = [];
      var now = new Date();
      this.record.date = {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate()
      };
      if (this.branches.length > 0) {
        this.record.branch_id = this.branches[0].id;
        this.fieldsForm.updateSlots(false);
      }
    }, 50);
  }

  ngOnInit() {
    this.currentStep = "1";
    this.reset();
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.fbId = params["fbid"];
      this.record.fbscopeid = params["fbid"];
      this.reservationformService
        .retrieveMetadata(params)
        .subscribe((response: any) => {
          this.SocialMediaLinkCustomLabel = response.metaData.SocialMediaLinkCustomLabel; 
          this.acceptInstagramOnly = +response.metaData.acceptInstagramOnly === 1;
          this.seatingType = +response.metaData.seatingType === 1;
          this.showSlotEndTime = +response.metaData.showSlotEndTime === 1;
          this.mobileNumberAtGlMandatory = +response.metaData.mobileNumberAtGlMandatory === 1;
          this.cutOffTime = +response.metaData.cutOffTime === 1;
          this.fbHeadMandatory = +response.metaData.fbHeadMandatory === 1;
          this.fbGuestMandatory = +response.metaData.fbGuestMandatory === 1;
          this.emailGuestMandatory = +response.metaData.emailGuestMandatory === 1;
          this.commentsLabel = response.metaData.commentsCustomLabel;
          this.acceptInternationalNumbers = +response.metaData.acceptInternationalNumbers === 1;
          this.disclaimerText = response.metaData.disclaimerText;
          this.renderer.addClass(document.body, response.metaData.cssclass);
          this.imageSrc =
          this.globals.UPLOADS + "logos/" + response.metaData.logo;
          this.injectTicketPrices(response.branches);
          this.branches = response.branches;
          this.publicTags = response.tags;
          this.record.typeid = response.metaData.reservationType
          this.record.branch_id = this.branches[0].id;
          setTimeout(() => {
            this.fieldsForm.updateSlots(false);
            this.fieldsForm.updateTags();
          }, 40);

          if (
            this.record.typeid == null ||
            this.record.typeid == undefined ||
            this.record.typeid == ''
          ) {
            this.record.typeid = 1
          }
          if (
            typeof response.metaData.starttext !== "undefined" &&
            response.metaData.starttext != "" &&
            response.metaData.starttext != null
          ) {
            this.startText = response.metaData.starttext;
          }
          if (
            typeof response.metaData.endtext !== "undefined" &&
            response.metaData.endtext != "" &&
            response.metaData.endtext != null
          ) {
            this.endText = response.metaData.endtext;
          }
          if (
            typeof response.metaData.notetext !== "undefined" &&
            response.metaData.notetext != "" &&
            response.metaData.notetext != null
          ) {
            this.noteText = response.metaData.notetext;
          }

          //Check If Customer is validate
          if (response.customer !== null) {
            this.mobileNoIsReadOnly = true;
            this.record.fname = response.customer.fname;
            this.record.lname = response.customer.lname;
            this.record.mobileno = response.customer.main_profile.mobileno;
            this.record.gender = response.customer.gender;
            this.record.email = response.customer.email;
            this.record.fblink = response.customer.fblink;
          }
          if (response.metaData.pixelId) {
            (window as any).fbq('init', response.metaData.pixelId);
            (window as any).fbq('track', 'PageView');
          }

          this.metaDataLoaded = true;
        });
    });
  }

  chooseMale() {
    this.record.gender = "m";
  }

  chooseFemale() {
    this.record.gender = "f";
  }

  onValidatePax(isValid) {
    this.maxPaxValid = isValid
  }

  onValidateMinPax(isValid) {
    this.minPaxValid = isValid
  }

  injectTicketPrices(branches) {
    for (var i = 0; i < branches.length; i++) {
      for (var j = 0; j < branches[i].slots.length; j++) {
        if (branches[i].slots[j].ticketmode) {
          utils.injectTicketsAdvancedParams(branches[i].slots[j].ticketprices);
          utils.filterTicketsForPublic(branches[i].slots[j].ticketprices);
        }
      }
    }
  }

  onSubmit() {
    this.showStep2();
  }

  onSubmit2() {
    if (this.record.pax == 0) {
      return;
    }
    if (!this.validate()) {
      return;
    }

    // Validate tag selection
    if (!this.validateAllTagSelections()) {
      return;
    }

    var tagsProcessResults = this.fieldsForm.processTags();
    if (tagsProcessResults.haveError) {
      return;
    }
    this.record.tags = tagsProcessResults.selectedTags;

    if (this.showGuestsList) {
      this.showGlStep();
      return;
    }
    this.showStep3();
  }

  validateAllTagSelections(): boolean {
    const tagCategories = this.fieldsForm.publicTags;

    for (let tagCategory of tagCategories) {
      this.fieldsForm.validateTagSelection(tagCategory);
      if (tagCategory.minError || tagCategory.maxError) {
        return false;
      }
    }
    return true;
  }

  stepBackFromConfirm() {
    if (this.showGuestsList) {
      this.showGlStep();
      return;
    }
    this.showStep2();
  }

  addReservation() {
    if (!this.validate()) {
      return;
    }
    this.loading = true;
    this.reservationformService
      .addReservation({
        token: this.token,
        record: this.record,
        guests: this.guests
      })
      .subscribe(
        (response: any) => {
          this.loading = false;
          if (
            typeof response["guestsListIssues"] !== "undefined" &&
            response["guestsListIssues"].length > 0
          ) {
            alertFunctions.manageListIssues(
              "Reservation Request created with issues",
              response["guestsListIssues"]
            );
          } else {
            alertFunctions.info(
              "Reservation request sent",
              "We have recieved your reservation request. We will contact you shorty."
            );
          }

          //Navigate To Manage Reservation page
          var url = "manage-reservation/" + response.reservation.referencecode;
          if (typeof this.fbId !== "undefined" && this.fbId !== "") {
            url += "/" + this.fbId;
          }
          this.router.navigate([url]);

          this.reset();
        },
        response => {
          this.loading = false;
        }
      );
  }

  validate() {
    var basicData = this.validateHostData();
    if (!basicData) {
      return false;
    }
    return basicData;
  }

  validateGuestlistStep() {
    if (!this.validateGuestlist()) {
      return;
    }
    this.showStep3();
  }

  validateHostData() {
    if (!this.isTicketType) {
      return true;
    }
    var ticketStatus = this.validateTicket(this.record.defaultticketcat);
    var fullname = this.record.fname + " " + this.record.lname;
    if (ticketStatus == -1) {
      alertFunctions.error(
        this.MESSAGES_TICKETSOLDOUT_TITLE,
        fullname + this.MESSAGES_TICKETSOLDOUT_DESC
      );
      return false;
    }
    if (ticketStatus == -2) {
      alertFunctions.error(
        this.MESSAGES_TICKETINVALIDTYPE_TITLE,
        fullname + this.MESSAGES_TICKETINVALIDTYPE_DESC
      );
      return false;
    }
    return true;
  }

  hasDuplicateFbLinks(): boolean {
    let fbLinksSet = new Set();
    return this.guests.some(guest => {
      // Skip empty social media links (null, undefined, or empty string)
      if (!guest.fblink || guest.fblink.trim() === '') {
        return false;
      }
      if (fbLinksSet.has(guest.fblink)) {
        return true;
      }
      fbLinksSet.add(guest.fblink);
      return false;
    });
  }

  validateGuestlist() {
    if (!this.showGuestsList) {
      return true;
    }

    this.guests = this.guestlistForm.guests;

    // Check if the guest list is complete
    for (let guest of this.guests) {
      if (!this.isGuestFormComplete(guest)) {
        alertFunctions.error(
          "Guestlist Error",
          "The reservation guest list is incomplete. Please add all the guest in your party excluding yourself."
        );
        return false;
      }
    }

    var genderRatioStatus = this.validateGenderRatio();
    if (genderRatioStatus == -1) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of females Guests must be equal or more than the number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -2) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of Females Guests must be exactly equal to the number of male guests."
      );
      return false;
    }
    if (genderRatioStatus == -3) {
      alertFunctions.error(
        "Gender Ratio is invalid",
        "Number of males Guests must be equal or more than the number of females guests."
      );
      return false;
    }

    var sizeToCompare = this.guests.length + 1;
    if (sizeToCompare != this.record.pax) {
      // Size Error
      alertFunctions.error(
        "Guestlist Error",
        "The reservation guest list is incomplete. Please add all the guest in your party excluding yourself."
      );
      return false;
    }
   
    
    var arrayOfNames = [];
    var arrayOfMobiles = [];
    var arrayOfFbLinks = [];
    arrayOfNames.push(this.record.fname + " " + this.record.lname);
    arrayOfMobiles.push(this.record.mobileno);
    arrayOfFbLinks.push(this.record.fblink);

    if(this.hasDuplicateFbLinks()) {
      alertFunctions.error(
        "Guestlist Error",
        "The Guestlist can not have repeating Social Media Link/can not be the same Social Media Link as the request host's Social Media Link."
      );
      return false;
    }


    for (var i = 0; i < this.guests.length; i++) {
      
      // Only compare social media links if both host and guest have provided links
      if (this.guests[i].fblink && this.guests[i].fblink.trim() !== '' && 
          arrayOfFbLinks[0] && arrayOfFbLinks[0].trim() !== '' && 
          String(this.guests[i].fblink) === String(arrayOfFbLinks[0])) {
        alertFunctions.error(
          "Guestlist Error",
          "The Guestlist can not have repeating Social Media Link/can not be the same Social Media Link as the request host's Social Media Link."
        );
        return false;
      }
      var fullname = this.guests[i].fname + " " + this.guests[i].lname;
      var checkFullName = arrayOfNames.indexOf(fullname);
      if (checkFullName === -1) {
        arrayOfNames.push(fullname);
      } else {
        alertFunctions.error(
          "Guestlist Error",
          "The Guestlist can not have repeating names/can not be the same name as the request host's name."
        );
        return false;
      }
      if (typeof this.guests[i].mobileno !== "undefined" && this.guests[i].mobileno != "") {
        var checkMobiles = arrayOfMobiles.indexOf(this.guests[i].mobileno);
        if (checkMobiles === -1) {
          arrayOfMobiles.push(this.guests[i].mobileno);
        } else {
          alertFunctions.error(
            "Guestlist Error",
            "The Guestlist can not have repeating mobile numbers/can not be the same name as the request host's mobile number."
          );
          return false;
        }
      }

      // Checking Tickets Types (if Ticket mode)
      if (this.isTicketType) {
        var ticketStatus = this.validateTicket(this.guests[i].ticketcat_id);
        if (ticketStatus == -1) {
          alertFunctions.error(
            this.MESSAGES_TICKETSOLDOUT_TITLE,
            fullname + this.MESSAGES_TICKETSOLDOUT_DESC
          );
          return false;
        }
        if (ticketStatus == -2) {
          alertFunctions.error(
            this.MESSAGES_TICKETINVALIDTYPE_TITLE,
            fullname + this.MESSAGES_TICKETINVALIDTYPE_DESC
          );
          return false;
        }
      }
    }
    return true;
  }

  isGuestFormComplete(guest) {
    return guest.fname && guest.lname &&
      (!this.mobileNumberAtGlMandatory || guest.mobileno) &&
      (!this.isTicketType || guest.ticketcat_id) &&
      (!this.emailGuestMandatory || guest.email) &&
      (!this.fbGuestMandatory || guest.fblink);
  }

  validateTicket(ticketId) {
    var ticketCategory = utils.getTicketCategoryById(ticketId, this.ticketPrices);
    if (ticketCategory.soldFlag) {
      return -1;
    }
    if (
      (ticketCategory.ttype == "2" && this.record.typeid != "1") ||
      (ticketCategory.ttype == "3" && this.record.typeid != "2")
    ) {
      return -2;
    }
    return true;
  }

  validateGenderRatio() {
    var selectedSlot = this.fieldsForm.getSlotById(this.record.slot_id);
    var ratioType = selectedSlot.genderratio;
    if (ratioType == null || ratioType == "0" || ratioType == 0) {
      return "0";
    }
    var totalNumberOfMales = 0;
    var totalNumberOfFemales = 0;
    if (this.record.gender == "m") {
      totalNumberOfMales++;
    }
    if (this.record.gender == "f") {
      totalNumberOfFemales++;
    }
    for (var i = 0; i < this.guests.length; i++) {
      if (this.guests[i].gender == "m") {
        totalNumberOfMales++;
      }
      if (this.guests[i].gender == "f") {
        totalNumberOfFemales++;
      }
    }
    switch (ratioType) {
      case "1":
      case 1:
        if (totalNumberOfFemales < totalNumberOfMales) {
          return -1;
        }
        break;
      case "2":
      case 2:
        if (totalNumberOfFemales !== totalNumberOfMales) {
          return -2;
        }
        break;
      case "3":
      case 3:
        if (totalNumberOfFemales > totalNumberOfMales) {
          return -3;
        }
        break;
    }
    return "0";
  }

  showLandingStep() {
    this.stepTitle = "Make a reservation request";
    this.titleFontLarge = true;
    this.titleSpaceLarge = true;
    this.currentStep = "0";
  }

  showStep1() {
    this.stepTitle = "Personal Information";
    this.titleFontLarge = false;
    this.titleSpaceLarge = false;
    this.currentStep = "1";
  }

  showStep2() {
    this.stepTitle = "Reservation Information";
    this.titleFontLarge = false;
    this.titleSpaceLarge = false;
    this.currentStep = "2";
    this.fieldsForm.checkGlExcludedCategories()
  }

  showGlStep() {
    this.stepTitle = "Guest list";
    this.titleFontLarge = false;
    this.titleSpaceLarge = false;
    this.currentStep = "g";
  }

  showStep3() {
    this.stepTitle = "Review Reservation";
    this.titleFontLarge = false;
    this.titleSpaceLarge = false;
    this.repopulateStep3Page();
    this.currentStep = "3";
  }

  repopulateStep3Page() {
    this.formattedBranch = "-";
    this.formattedSlot = "-";
    this.formattedDate = "-";
    var branch = this.getCurrentBranch();
    if (branch) {
      this.formattedBranch = branch.name;
    }
    var selectedSlot = this.fieldsForm.getSlotById(this.record.slot_id);
    this.formattedSlot = utils.formatSlotNameForPublic(selectedSlot, this.showSlotEndTime);
    this.formattedDate = utils.formatDateCustomObjectToSql(this.record.date);
    //this.showGuestsList = this.fieldsForm.showGuestsList;
    this.guests = this.guestlistForm.guests;
    //this.isTicketType = this.fieldsForm.isTicketType;
  }

  getCurrentBranch() {
    for (var i = 0; i < this.branches.length; i++) {
      if (this.branches[i].id == this.record.branch_id) {
        return this.branches[i];
      }
    }
    return false;
  }

  onSlotChange(selectedSlot) {
    if (selectedSlot.ticketmode) {
      this.reservationformService
        .retrieveSoldTickets({ token: this.token, id: selectedSlot.id })
        .subscribe((response: any) => {
          this.injectTicketSoldCounts(selectedSlot.id, response);
        });
    }
  }

  injectTicketSoldCounts(slotId, dic) {
    for (var i = 0; i < this.branches.length; i++) {
      for (var j = 0; j < this.branches[i].slots.length; j++) {
        if (this.branches[i].slots[j].id == slotId) {
          for (
            var k = 0;
            k < this.branches[i].slots[j].ticketprices.length;
            k++
          ) {
            this.branches[i].slots[j].ticketprices[k].soldFlag =
              dic[this.branches[i].slots[j].ticketprices[k].id];
          }
        }
      }
    }
  }

  onGuestListStatusChange(newStatus) {
    this.showGuestsList = newStatus;
  }

  onTicketTypeChange(ticketType) {
    this.isTicketType = ticketType;
  }

  onTicketPricesChange(ticketPrices) {
    this.ticketPrices = ticketPrices;
  }
}
